import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Dropdown } from 'office-ui-fabric-react';
import { isNil, isEmpty } from 'lodash';
import styles from './TextField.style';
import TextField from './TextField';
import { operatorOptions } from '../../constants';

const TextFieldWithOperator = ({ field, form, showOperator, ...other }) => {
  const [operatorState, setOperatorState] = useState(
    field.value?.operator ? field.value.operator : 'equals',
  );

  return (
    <Stack horizontal>
      {showOperator && (
        <Stack.Item className={styles.rightPadding}>
          <Dropdown
            aria-label="Operator Dropdown"
            options={operatorOptions}
            defaultSelectedKey={operatorState}
            onChange={(event, option) => {
              setOperatorState(option.key);
              if (!isNil(field.value) && !isEmpty(field.value)) {
                form.setFieldValue(field.name, { ...field.value, operator: option.key });
              }
            }}
          />
        </Stack.Item>
      )}

      <Stack.Item grow={1}>
        <TextField
          field={{
            ...field,
            onChange: () => {}, // this is needed, else the onchange sets the field value to text's string value
          }}
          form={form}
          {...other}
          onUpdate={newValue => {
            if (showOperator) {
              form.setFieldValue(field.name, {
                val: newValue,
                operator: showOperator ? operatorState : undefined,
              });
            } else {
              form.setFieldValue(field.name, newValue);
            }
          }}
        />
      </Stack.Item>
    </Stack>
  );
};

TextFieldWithOperator.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    setFieldTouched: PropTypes.func,
  }),
  showOperator: PropTypes.bool,
};

TextFieldWithOperator.defaultProps = {
  form: {
    touched: {},
    errors: {},
    isSubmitting: false,
    setFieldTouched: () => {},
  },
  showOperator: false,
};

export default TextFieldWithOperator;
